import React from 'react';
import sIcon1 from '../../images/icon/ab-page-icon01.svg'
import sIcon2 from '../../images/icon/ab-page-icon02.svg'
import sIcon3 from '../../images/icon/ab-page-icon03.svg'
import sIcon4 from '../../images/icon/ab-page-icon04.svg'


const FeaturesSection = (props) => {

    return (
        <section className="fanfact pt-125 pb-125">
            <div className="container">
                <div className="ap-feature_wrap">
                    <div className="row mt-none-30">

                        <div className="col-lg-3 col-md-6 mt-30">
                            <div className="ap-feature-item wow fadeInUp" 
                                data-wow-delay="0ms" data-wow-duration="600ms">
                                <div className="xb-item--icon"><img src={sIcon1} alt="" /></div>

                                {/* CHANGED */}
                                <h4 className="xb-item--title">Result-Driven ERP</h4>
                                <p className="xb-item--content">
                                    We deliver powerful Odoo ERP, manufacturing, and inventory solutions 
                                    that create real operational impact.
                                </p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 mt-30">
                            <div className="ap-feature-item wow fadeInUp" 
                                data-wow-delay="100ms" data-wow-duration="600ms">
                                <div className="xb-item--icon"><img src={sIcon2} alt="" /></div>

                                {/* CHANGED */}
                                <h4 className="xb-item--title">Proactive eCommerce</h4>
                                <p className="xb-item--content">
                                    From Magento to Shopify, we anticipate requirements and build stores 
                                    that scale without friction.
                                </p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 mt-30">
                            <div className="ap-feature-item wow fadeInUp" 
                                data-wow-delay="200ms" data-wow-duration="600ms">
                                <div className="xb-item--icon"><img src={sIcon3} alt="" /></div>

                                {/* CHANGED */}
                                <h4 className="xb-item--title">Scalable Solutions</h4>
                                <p className="xb-item--content">
                                    Whether ERP or mobile apps, we build systems designed for long-term 
                                    stability and sustainable business growth.
                                </p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 mt-30">
                            <div className="ap-feature-item wow fadeInUp" 
                                data-wow-delay="300ms" data-wow-duration="600ms">
                                <div className="xb-item--icon"><img src={sIcon4} alt="" /></div>

                                {/* CHANGED */}
                                <h4 className="xb-item--title">High-Speed Delivery</h4>
                                <p className="xb-item--content">
                                    Fast and efficient development in React, React Native & Odoo 
                                    ensures your project goes live on time.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default FeaturesSection;
